import List from '../../../utils/list';

const mutation = {
  initialReset(state) {
    state.list = [];
    state.filter = {};
    state.filter.page = 1;
    state.filter.page_limit = 25;
    state.hasEmpty = false;
    state.isLoading = false;
  },
  resetAll(state, data) {
    state.list = [];
    state.all = data;
  },

  paginationCheck(state, status) {
    state.isPaginating = status;
  },

  SET_LOADING(state, status) {
    state.isLoading = status;
  },

  setExcludeVehicles(state, data) {
    state.excludeList = data;
  },

  SET_LIST(state, data) {
    const result = (state.filter.page > 1) ? state.list.concat(data) : data;
    state.list = result;
    if (data.length) {
      state.filter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },

  SET_INDENTS(state, data) {
    state.indentslist = data;
  },

  setPage(state, page) {
    state.filter.page = page;
  },

  setHasEmpty(state, data) {
    state.hasEmpty = data;
  },

  appendNew(state, { data }) {
    const result = List.new(state.list, data);
    state.list = result;
  },
  removeExisting(state, { data }) {
    const result = List.remove(state.list, data);
    state.all = result;
  },
  updateExisting(state, { data, keyToCompare }) {
    const result = List.update(state.list, data, keyToCompare);
    state.list = result;
  },
  setLoadingStatus(state, status) {
    state.isLoading = status;
  },
  setuploadStatus(state, status) {
    state.isUploading = status;
  },
  SET_ALL_ACTIVE_FF(state, data) {
    state.activeListFF = data;
  },
  SET_ALL_ACTIVE_CONTAINER(state, data) {
    state.activeListContainer = data;
  },
  SET_ALL_ACTIVE_CHA(state, data) {
    state.activeListCha = data;
  },
  SET_ALL_ACTIVE_PORT(state, data) {
    state.activeListPort = data;
  },
  setDownloadStatus(state, status) {
    state.isDownloading = status;
  },
  setHeader(state, data) {
    state.header = data;
  },
  setShowLoading(state, status) {
    state.isShowLoading = status;
  },
  setAll(state, data) {
    const result = (state.filter.page > 1) ? state.all.concat(data) : data;
    state.all = result;
    if (data.length) {
      state.filter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },
  setCurrentBdr(state, data) {
    state.currentBdr = data;
  },
  setBdrSlabs(state, data) {
    state.bdrSlabs = data;
  },
};

export default mutation;
